import React from 'react';

export const Pdf = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width ?? '52'}
    height={height ?? '52'}
    viewBox="0 0 44 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.6 0.5H13.2C10.78 0.5 8.8 2.48 8.8 4.9V31.3C8.8 33.72 10.78 35.7 13.2 35.7H39.6C42.02 35.7 44 33.72 44 31.3V4.9C44 2.48 42.02 0.5 39.6 0.5ZM20.9 17C20.9 18.826 19.426 20.3 17.6 20.3H15.4V24.7H12.1V11.5H17.6C19.426 11.5 20.9 12.974 20.9 14.8V17ZM31.9 21.4C31.9 23.226 30.426 24.7 28.6 24.7H23.1V11.5H28.6C30.426 11.5 31.9 12.974 31.9 14.8V21.4ZM40.7 14.8H37.4V17H40.7V20.3H37.4V24.7H34.1V11.5H40.7V14.8ZM15.4 17H17.6V14.8H15.4V17ZM4.4 9.3H0V40.1C0 42.52 1.98 44.5 4.4 44.5H35.2V40.1H4.4V9.3ZM26.4 21.4H28.6V14.8H26.4V21.4Z"
      fill={color || '#CB2828'}
    />
  </svg>
);
